import React, { FC } from 'react'
import { PaginationState } from './types'

interface TableFooterPaginationProps {
  paginationState: PaginationState
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
  loading?: boolean
}

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 200]

export const TableFooterPagination: FC<TableFooterPaginationProps> = ({
  paginationState,
  onPageChange,
  onPageSizeChange,
  loading = false,
}) => {
  const { page, pageSize, total, totalPages } = paginationState

  const startRecord = total === 0 ? 0 : (page - 1) * pageSize + 1
  const endRecord = Math.min(page * pageSize, total)

  const canGoPrevious = page > 1
  const canGoNext = page < totalPages

  return (
    <div className="d-flex align-items-center justify-content-between py-3 px-4 border-top">
      {/* Left: Record range */}
      <div className="text-muted">
        Showing {startRecord} to {endRecord} of {total} records
      </div>

      {/* Right: Page size selector + pagination buttons */}
      <div className="d-flex align-items-center gap-3">
        {/* Page size selector */}
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted">Rows per page:</span>
          <select
            className="form-select form-select-sm"
            style={{ width: 'auto' }}
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            disabled={loading}
          >
            {PAGE_SIZE_OPTIONS.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>

        {/* Pagination controls */}
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-sm btn-light"
            onClick={() => onPageChange(page - 1)}
            disabled={!canGoPrevious || loading}
          >
            <i className="bi bi-chevron-left"></i>
            Previous
          </button>

          <span className="text-muted px-2">
            Page {page} of {totalPages || 1}
          </span>

          <button
            className="btn btn-sm btn-light"
            onClick={() => onPageChange(page + 1)}
            disabled={!canGoNext || loading}
          >
            Next
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  )
}
